module.exports = __webpack_public_path__ + "img/DOH_PHL.ed701714.png";